/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Button from '@dtvgo/button';
import { usePlayerState, PlayerState } from '@dtvgo/player-context';

/* Utils */
import { withCursorVisibilityFilter } from '../../../../hocs/withCursorVisibilityFilter.hoc';
import { ClassNames } from '../../../../utils/misc';

/* Styles */
import './PlayPause.scss';

const PlayPauseClassNames = ClassNames.component('play-pause');

function PlayPause({
  children,
  primary,
  className,
  disabled,
  focused,
  onMouseDown,
  onMouseEnter,
}) {
  return (
    <Button
      primary={primary}
      className={PlayPauseClassNames.block({ focused }, className)}
      disabled={disabled}
      icon={usePlayerState() === PlayerState.PAUSED ? 'play' : 'pause'}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      {children}
    </Button>
  );
}

PlayPause.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.bool,
  focused: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

PlayPause.defaultProps = {
  children: undefined,
  primary: false,
  focused: false,
  className: '',
  disabled: false,
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

export default withCursorVisibilityFilter(memo(PlayPause));
